<template>
  <picture class="image-wraper" ref="imageWrapper">
    <template v-if="isIntersecting">
      <source v-if="support_image == 'avif'" :srcset="computedSrc.avif" type="image/avif" />
      <source v-if="support_image == 'webp'" :srcset="computedSrc.webp" type="image/webp" />
      <source v-if="support_image == 'png'" :srcset="computedSrc.png" type="image/png" />
      <img loading="lazy" :style="computedSize" alt="" />
    </template>
  </picture>
</template>
<script setup>
import config from '@img/config.json';
import { onMounted, watch } from 'vue';
import px2vw from '@/utils/px2vw_v2';
const { support_lazy_image, support_image, is_mobile } = inject('GlobalStore');
const props = defineProps({
  src: {
    type: String,
  },
  size: {
    type: Object,
  },
  // 这个是完整地址,这个有值，直接使用这个
  init_src: {
    type: String,
  },
});
const computedSrc = ref({ avif: '', webp: '', png: '' });
async function loadImageUrls() {
  if (props.init_src) {
    computedSrc.value = {
      avif: props.init_src,
      webp: props.init_src,
      png: props.init_src,
    };
  } else {
    let src = config[props.src].src;
    if (src) {
      computedSrc.value = {
        avif: `${src}.avif`,
        webp: `${src}.webp`,
        png: `${src}.png`,
      };
    } else {
      console.error('您使用了没有经过脚本处理的图片', props.src);
    }
  }
}

const computedSize = computed(() => {
  if (props.size) {
    if (props.size.radius) {
      return {
        'border-radius': `${props.size.radius}%`,
        width: px2vw(props.size.width, is_mobile.value),
        height: px2vw(props.size.height, is_mobile.value),
      };
    } else {
      return {
        width: px2vw(props.size.width, is_mobile.value),
        height: px2vw(props.size.height, is_mobile.value),
      };
    }
  } else {
    var size = config[props.src];
    if (size) {
      return {
        width: px2vw(size.width, is_mobile.value),
        height: px2vw(size.height, is_mobile.value),
      };
    } else {
      console.error('您使用了没有经过脚本处理的图片', props.src);
    }
  }
});
const isIntersecting = ref(false);
const observer = ref(null);
const imageWrapper = ref(null);
function handleIntersection(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      isIntersecting.value = true;
      observer.value.disconnect(); // 图片加载后，停止观察
    }
  });
}

onMounted(async () => {
  if (support_lazy_image.value) {
    isIntersecting.value = true;
  } else {
    observer.value = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px',
      threshold: 0.1,
    });
    if (imageWrapper.value) {
      observer.value.observe(imageWrapper.value);
    }
  }

  loadImageUrls();
});

watch(() => props.src, (nVal) => {
  if (!!nVal) {
    loadImageUrls();
  }
})

onBeforeUnmount(() => {
  if (observer.value) {
    observer.value.disconnect();
  }
});
</script>
<style>
.image-wraper {
  display: flex;
  align-items: center;
}

.image-circle {
  border-radius: 50%;
}
</style>
